var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVkycIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.101,
    height: 14.824,
    viewBox: "0 0 20.101 14.824",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_163112",
    "data-name": "Group 163112",
    transform: "translate(-1 -7.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21306",
    "data-name": "Path 21306",
    d: "M18.421,7.3H3.68a1.787,1.787,0,0,0-1.8,1.8v9.967H1.419A.4.4,0,0,0,1,19.486v.335a2.324,2.324,0,0,0,2.3,2.3H18.8a2.324,2.324,0,0,0,2.3-2.3v-.335a.4.4,0,0,0-.419-.419h-.461V9.1A1.814,1.814,0,0,0,18.421,7.3ZM2.717,9.1a.948.948,0,0,1,.963-.963h14.74a.948.948,0,0,1,.963.963v9.967H15.824a4.452,4.452,0,0,0-3.978-2.554H10.255a4.381,4.381,0,0,0-3.978,2.554H2.717ZM14.9,19.067H7.2a3.64,3.64,0,0,1,3.057-1.717h1.591A3.683,3.683,0,0,1,14.9,19.067Zm5.36.838a1.434,1.434,0,0,1-1.466,1.34H3.3A1.493,1.493,0,0,1,1.838,19.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21307",
    "data-name": "Path 21307",
    d: "M20.841,18.651c1.717,0,3.141-2.136,3.141-3.853a3.141,3.141,0,0,0-6.281,0C17.7,16.558,19.124,18.651,20.841,18.651Zm0-6.114a2.288,2.288,0,0,1,2.3,2.261c0,1.34-1.089,3.015-2.3,3.015-1.173,0-2.3-1.717-2.3-3.015A2.288,2.288,0,0,1,20.841,12.538Z",
    transform: "translate(-9.707 -2.557)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkycIcon);
export default __webpack_public_path__ + "static/media/vkyc-icon.6bae6041146768c3f2d34baa879c1a31.svg";
export { ForwardRef as ReactComponent };